var btnLabel = ''
var need_debug = true

function debuglog(log, info1 = '', info2 = '', info3 = '') {
  if (need_debug) {
    console.log(log, info1, info2, info3)
  }
}

function reduceArrayDimention(ary) {
  if (!ary || typeof ary !== 'object' || typeof ary[0] !== 'object') {
    debuglog('no vaild multi-dimension array')
    return null
  }

  return ary[0].concat(...ary.slice(1))
}

function makeFirstLetterUppercase(str) {
  var splitStr = str.toLowerCase().split(' ')
  for (var i = 0; i < splitStr.length; i++) {
    // You do not need to check if i is larger than splitStr length, as your for does that for you
    // Assign it back to the array
    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1)
  }
  // Directly return the joined string
  return splitStr.join(' ')
}

function formatNumber(num) {
  if (!num) {
    return 0
  }
  const val = typeof num === 'string' ? parseFloat(num) : num
  if (val === parseInt(val)) {
    return parseInt(val)
  } else {
    return val.toFixed(2)
  }
}

function getFirstMonthOfYear(sep) {
  return moment().startOf('year').format(`YYYY$${sep}MM`)
}

function getLastMonthOfYear(sep) {
  return moment().endOf('year').format(`YYYY$${sep}MM`)
}

function getFirstDateOfMonth(sep) {
  return moment().startOf('month').format(`YYYY$${sep}MM-DD`)
}

function getCurrentDateOfMonth(sep) {
  return moment().add(1, 'day').format(`YYYY${sep}MM${sep}DD`)
}

function getFromDateWithPeriod(period, sep) {
  return moment().subtract(period, 'month').subtract(1, 'day').format(`YYYY${sep}MM${sep}DD`)
}

function arrayFind(arr, fn) {
  for (var i = 0, len = arr.length; i < len; ++i) {
    if (fn(arr[i])) {
      return i
    }
  }
  return -1
}

function getUrlParameter(name) {
  const updated_name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
  const regex = new RegExp('[\\?&]' + updated_name + '=([^&#]*)')
  const results = regex.exec(location.search)
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
}

function getFilterItems() {
  const filter_data = getUrlParameter(FILTER_KEYNAME)
  return filter_data.split('|').map((_item) => _item.split(':').join(' '))
}

function convertToSlug(label) {
  return label
    .toLowerCase()
    .replace(/[^\w ]+/g, '')
    .replace(/\s+/g, '-')
}

function getTrigrams(f_name, l_name) {
  return (f_name.charAt(0) + l_name.charAt(0) + l_name.slice(-1)).toUpperCase()
}
//
// function eraseCookieFromAllPaths(name) {
//     // This function will attempt to remove a cookie from all paths.
//     var pathBits = location.pathname.split('/');
//     var pathCurrent = ' path=';
//
//     // do a simple pathless delete first.
//     document.cookie = name + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT;';
//
//     for (var i = 0; i < pathBits.length; i++) {
//         pathCurrent += ((pathCurrent.substr(-1) != '/') ? '/' : '') + pathBits[i];
//         document.cookie = name + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT;' + pathCurrent + ';';
//     }
// }

function getCountryWithDifferentWeekends(user_locale) {
  var countries_with_diff_weekends = [
    { code: 'ae', weekends: [5, 6] },
    { code: 'af', weekends: [5, 6] },
    { code: 'dz', weekends: [5, 6] },
    { code: 'bh', weekends: [5, 6] },
    { code: 'eg', weekends: [5, 6] },
    { code: 'iq', weekends: [5, 6] },
    { code: 'il', weekends: [5, 6] },
    { code: 'jo', weekends: [5, 6] },
    { code: 'kw', weekends: [5, 6] },
    { code: 'ly', weekends: [5, 6] },
    { code: 'mv', weekends: [5, 6] },
    { code: 'om', weekends: [5, 6] },
    { code: 'qa', weekends: [5, 6] },
    { code: 'sa', weekends: [5, 6] },
    { code: 'sd', weekends: [5, 6] },
    { code: 'sy', weekends: [5, 6] },
    { code: 'ye', weekends: [5, 6] },
  ]

  return countries_with_diff_weekends.find(function (country) {
    return user_locale === country.code
  })
}

function getAllWeekendsBetween(dDate1, dDate2, locale, get_count) {
  if (dDate1 > dDate2) return false

  var user_locale = locale || 'en'
  var user_weekends = []

  var country_with_diff_weekends = getCountryWithDifferentWeekends(user_locale)

  if (country_with_diff_weekends) {
    user_weekends = country_with_diff_weekends.weekends
  } else {
    user_weekends = [0, 6]
  }

  var date = new Date(dDate1)
  var dates = []
  let count = 0
  while (date < dDate2) {
    if (user_weekends.indexOf(date.getDay()) !== -1) {
      dates.push(new Date(date))
      count++
    }
    date.setDate(date.getDate() + 1)
  }
  if (get_count) {
    return count
  }
  return dates
}

function getAllWeekendsInHoursBetween(dDate1, dDate2, locale) {
  let hours = 0
  let date1 = moment(dDate1)
  let date2 = moment(dDate2)
  while (date1.isSameOrBefore(date2)) {
    if (isWeekend(date1.toDate(), locale)) {
      hours += 24
    }
    date1.add(1, 'days')
  }
  return hours
}

function isWeekend(date, locale) {
  var country_with_diff_weekends = getCountryWithDifferentWeekends(locale)

  if (country_with_diff_weekends) {
    if (country_with_diff_weekends.weekends.indexOf(date.getDay()) !== -1) {
      return true
    }
  } else {
    if ([0, 6].indexOf(date.getDay()) !== -1) {
      return true
    }
  }
  return false
}

function getStartPlusWeekends(start_date, end_date, locale) {
  let start = moment(start_date).startOf('day')
  let new_start = moment(start_date)
  let end = moment(end_date).startOf('day')
  if (start.isSameOrAfter(end)) return start_date

  while (true) {
    if (start.isSameOrAfter(end) && isWeekend(end.toDate(), locale) === false && isWeekend(new_start.toDate(), locale) === false) {
      break
    } else {
      if (isWeekend(end.toDate(), locale)) {
        new_start.subtract(1, 'days')
      }
      end.subtract(1, 'days')
    }
  }

  return new_start.toDate()
}

function getEndPlusWeekends(start_date, end_date, locale) {
  let start = moment(start_date).startOf('day')
  let new_end = moment(end_date)
  let end = moment(end_date).startOf('day')
  if (start.isSameOrAfter(end)) return end_date

  while (true) {
    if (start.isSameOrAfter(end) && isWeekend(start.toDate(), locale) === false) {
      break
    } else {
      if (isWeekend(start.toDate(), locale)) {
        new_end.add(1, 'days')
      }
      start.add(1, 'days')
    }
  }

  return new_end.toDate()
}

function checkJsonString(str) {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}

function checkPasswordComplexity(pwd) {
  return pwd.length >= 6 && /[A-Z]/.test(pwd) && /[a-z]/.test(pwd) && /\d/.test(pwd)
}

function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}

function validatePhone(phone) {
  var re = new RegExp(/^[+]{0,1}[0-9]{1,4},{0,1}[-\/0-9]{6,16}$/g)
  var clearPhone = phone.replace(/[`~!@#$%^&*()_+|\-=?;:'",.<>\{\}\[\]\\\/]/gi, '')

  if (clearPhone.length > 6 && clearPhone.length < 17) {
    return re.test(phone)
  } else {
    return false
  }
}

function getCookieValue(name) {
  return document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''
}

function showResultMessage(dom, type = 2, default_msg = '') {
  const class_name = type === 2 ? 'success' : 'error gap-top-20'
  const msg = type === 2 ? i18next.t('common.done') : type === 1 ? i18next.t('common.required-field') : type === -1 ? default_msg : i18next.t('common.invalid-value')
  const msg_html = `
			<div class="${class_name} text-center">
					<div>
							${msg}
					</div>
			</div>
	`
  const msg_dom = $(msg_html)
  dom.append(msg_dom)

  setTimeout(function () {
    msg_dom.remove()
  }, 2000)
}

function showSlideMsg(msg) {
  if (!msg) {
    msg = i18next.t('common.changes-saved');
  }
  const msgDom = $('.slide-msg')

  msgDom.removeClass('show')
  msgDom.find('.text').html(msg)
  msgDom.addClass('show')
  setTimeout(function () {
    msgDom.removeClass('show')
  }, 3000)
}

function showTimerStatus(dom, timeAmount, done) {
  dom.attr('disabled', true)
  var countDown = timeAmount

  // Update the count down every 1 second
  const timer = setInterval(function () {
    if (countDown < 0) {
      clearInterval(timer)
      dom.html(i18next.t('common-ui.back-to-home'))
      done()
    } else {
      dom.html(countDown)
    }

    countDown--
  }, 1000)
}

function handleLoadingStatus(dom, flag) {
  if (flag) {
    btnLabel = dom.text()
    const loadingHtml = `
        <div class="loading-icon"></div>
    `
    dom.html(loadingHtml)
    dom.attr('disabled', true)
  } else {
    dom.html(btnLabel)
    dom.removeAttr('disabled')
  }
}

const doCrossAjaxPost = (function (_ajax) {
  var protocol = location.protocol,
    hostname = location.hostname,
    exRegex = RegExp(protocol + '//' + hostname),
    YQL = 'http' + (/^https/.test(protocol) ? 's' : '') + '://query.yahooapis.com/v1/public/yql?callback=?',
    query = 'select * from html where url="{URL}" and xpath="*"'

  function isExternal(url) {
    return !exRegex.test(url) && /:\/\//.test(url)
  }

  return function (o) {
    var url = o.url

    if (/get/i.test(o.type) && !/json/i.test(o.dataType) && isExternal(url)) {
      // Manipulate options so that JSONP-x request is made to YQL

      o.url = YQL
      o.dataType = 'json'

      o.data = {
        q: query.replace('{URL}', url + (o.data ? (/\?/.test(url) ? '&' : '?') + jQuery.param(o.data) : '')),
        format: 'xml',
      }

      // Since it's a JSONP request
      // complete === success
      if (!o.success && o.complete) {
        o.success = o.complete
        delete o.complete
      }

      o.success = (function (_success) {
        return function (data) {
          if (_success) {
            // Fake XHR callback.
            _success.call(
              this,
              {
                responseText: (data.results[0] || '')
                  // YQL screws with <script>s
                  // Get rid of them
                  .replace(/<script[^>]+?\/>|<script(.|\s)*?\/script>/gi, ''),
              },
              'success'
            )
          }
        }
      })(o.success)
    }

    return _ajax.apply(this, arguments)
  }
})(jQuery.ajax)

function doAjaxPost(url, data, success, err) {
  return $.ajax({
    type: 'POST',
    url: url,
    data: data,
    dataType: 'JSON',
    success: success,
    error: err,
  })
}

// The modern APIs (Brewery v2, knowledge base, assistant) read a JSON body and
// return numbers as numbers. doAjaxPost form-encodes, which turns every value
// into a string and loses nested objects.
function doAjaxPostJson(url, data, success, err) {
  return $.ajax({
    type: 'POST',
    url: url,
    data: JSON.stringify(data),
    contentType: 'application/json; charset=utf-8',
    dataType: 'JSON',
    success: success,
    error: err,
  })
}

function doAjaxGet(url, data, success, err) {
  return $.ajax({
    type: 'GET',
    url: url,
    data: data,
    dataType: 'JSON',
    success: success,
    error: err,
  })
}

function doAjaxGetHTML(url, data, success, err) {
  return $.ajax({
    type: 'GET',
    url: url,
    data: data,
    dataType: 'HTML',
    success: success,
    error: err,
  })
}

var doAjaxPostFile = function (url, input, progress_bar, success, err) {
  var formData = new FormData()

  $.each(input[0].files, function (i, file) {
    formData.append('user_file', file)
  })

  debuglog(input)

  return $.ajax({
    type: 'POST',
    url: url,
    data: formData,
    processData: false, // tell jQuery not to process the data
    contentType: false, // tell jQuery not to set contentType
    xhr: function () {
      // create an XMLHttpRequest
      var xhr = new XMLHttpRequest()

      // listen to the 'progress' event
      xhr.upload.addEventListener(
        'progress',
        function (evt) {
          if (evt.lengthComputable) {
            // calculate the percentage of upload completed
            var percentComplete = evt.loaded / evt.total
            percentComplete = parseInt(percentComplete * 100)

            // update the Bootstrap progress bar with the new percentage
            progress_bar.text(percentComplete + '%')
            progress_bar.width(percentComplete + '%')

            // once the upload reaches 100%, set the progress bar text to done
            if (percentComplete === 100) {
              progress_bar.html(i18next.t('common.done'))
              setTimeout(function () {
                progress_bar.html('')
              }, 1000)
            }
          }
        },
        false
      )

      return xhr
    },
    success: success,
    error: err,
  })
}

function doAjaxPostWithFile(url, input, progress_bar, form, success, err) {
  var formData = new FormData(form)

  var hasProgress = progress_bar && progress_bar.length > 0

  return $.ajax({
    type: 'POST',
    url: url,
    data: formData,
    processData: false, // tell jQuery not to process the data
    contentType: false, // tell jQuery not to set contentType
    cache: false,
    // async: false,
    xhr: function () {
      // create an XMLHttpRequest
      var xhr = new XMLHttpRequest()

      // listen to the 'progress' event
      xhr.upload.addEventListener(
        'progress',
        function (evt) {
          if (hasProgress && evt.lengthComputable) {
            // calculate the percentage of upload completed
            var percentComplete = evt.loaded / evt.total
            percentComplete = parseInt(percentComplete * 100)

            // update the Bootstrap progress bar with the new percentage
            debuglog(percentComplete + '%')
            progress_bar.text(percentComplete + '%')
            progress_bar.width(percentComplete + '%')

            // once the upload reaches 100%, set the progress bar text to done
            if (percentComplete === 100) {
              progress_bar.html(i18next.t('common.done'))
              setTimeout(function () {
                progress_bar.html('')
              }, 1000)
            }
          }
        },
        false
      )

      return xhr
    },
    success: success,
    error: err,
  })
}

function dateTimeFormat(date, add_hours) {
  if (add_hours === undefined) {
    add_hours = true
  }
  moment.tz.setDefault('UTC')
  if (add_hours) {
    return moment(date).tz(window.user_timezone).format('YYYY-MM-DD HH:mm')
  }

  var date1 = moment(date).tz(window.user_timezone).format('YYYY-MM-DD')

  moment.tz.setDefault(window.user_timezone)

  return date1
}

function dateFromDB(dateString) {
  var date = dateString.split('T')
  return date[0]
}

/**
 * The last explanation the server gave, and when.
 *
 * Most of the several hundred `showError()` call sites pass nothing, so the
 * modal read "Something went wrong. Please reload the page." even when the
 * server had said precisely what was wrong — "you have no licence for this
 * company", for instance. Nobody could act on that, and nobody could report it
 * either. Remembering the last message lets the generic call sites show it
 * without touching any of them.
 */
var lastServerError = { message: '', at: 0 }

/** Beyond this, the remembered message probably belongs to something else. */
var SERVER_ERROR_TTL = 10000

$(document).ajaxSuccess(function (event, xhr) {
  // The API answers 200 with `{ status: 'error', data: '...' }`, so a failure
  // arrives here rather than in the error handler.
  var body = xhr && xhr.responseJSON
  if (!body || body.status !== 'error') return
  if (typeof body.data !== 'string' || !body.data) return
  lastServerError = { message: body.data, at: Date.now() }
})

function showError(options, info) {
  debuglog('error info', options, info)
  if (!options) options = {}

  if (!options.modal) options.modal = $('.modal.common-modal')
  if (!options.header) options.header = i18next.t('common.error')
  if (!options.message && lastServerError.message && Date.now() - lastServerError.at < SERVER_ERROR_TTL) {
    options.message = lastServerError.message
  }
  if (!options.message) options.message = i18next.t('common.something-went-wrong-please-reload-page')
  if (!options.btn_text) options.btn_text = i18next.t('common.close')
  options.modal.find('.modal-dialog').removeClass().addClass('modal-dialog').addClass('small-confirm')
  options.modal
    .find('.modal-header .modal-title')
    .html('')
    .append('<h4>' + options.header + '</h4>')
  options.modal.find('.modal-body').html('').append(options.message)
  options.modal
    .find('.modal-footer')
    .html('')
    .append('<button type="button" class="btn btn-default" data-dismiss="modal">' + options.btn_text + '</button>')
  options.modal.modal(options.modal_options)
}

function showMessage(options, info) {
  if (!options) options = {}

  if (!options.modal) options.modal = $('.modal.common-modal')
  if (!options.header) options.header = ''
  if (!options.message) options.message = ''
  if (!options.btn_text) options.btn_text = 'Ok'
  options.modal.find('.modal-dialog').removeClass().addClass('modal-dialog').addClass('small-confirm')
  options.modal
    .find('.modal-header .modal-title')
    .html('')
    .append('<h4>' + options.header + '</h4>')
  options.modal.find('.modal-body').html('').append(options.message)
  options.modal
    .find('.modal-footer')
    .html('')
    .append('<button type="button" class="btn btn-default" data-dismiss="modal">' + options.btn_text + '</button>')
  options.modal.modal(options.modal_options)
}

function setModalError(modal) {
  modal.find('.modal-header .modal-title').html(`<h4 class="modal-title">${i18next.t('common.error')}</h4>`);
  modal.find('.modal-body').html(i18next.t('common.error-ocurred-try-again'));
  modal.find('.modal-footer .ok').remove();
}

function confirmDialog(modal, header, content, action_button, modal_options, done) {
  modal.find('.modal-dialog').removeClass().addClass('modal-dialog')
  if (modal_options && modal_options.modal_class) {
    modal.find('.modal-dialog').addClass(modal_options.modal_class)
  }
  modal.find('.modal-header .modal-title').html('<h4 class="modal-title">' + header + '</h4>')
  modal.find('.modal-body').html('').append(content)
  modal
    .find('.modal-footer')
    .html('')
    .append('<button type="button" class="btn btn-default no" data-dismiss="modal">' + (modal_options.close_btn_name ? modal_options.close_btn_name : i18next.t('common.close')) + '</button>')
  modal.find('.modal-footer').append('<button class="btn btn-primary ' + action_button.class + ' ok">' + action_button.name + '</button>')

  if (action_button.init) {
    action_button.init();
  }
  
  if (!action_button.custom_ok_event) {
    modal.off('click', '.ok')
    modal.off('click', '.no, .close')
    modal.one('click', '.ok', function () {
      modal.off('click', '.ok')
      var status
      var result
      var post_data = null
      if (action_button.loading && typeof action_button.loading === 'function') action_button.loading()
      if (action_button.post_data) post_data = action_button.post_data
      $.when(
        doAjaxPost(
          action_button.url,
          post_data,
          function (data) {
            result = data
            if (data.hasOwnProperty('status') && data.status === 'ok') {
              status = data.status
            } else {
              setModalError(modal);
            }
          },
          (sender, message, details) => setModalError(modal),
        )
      ).done(function () {
        if (!modal_options.disable_hide_modal) {
          modal.modal('hide')
        }
        if (done) {
          done(status, result)
        }
      })
    })
    modal.one('click', '.no, .close', function () {
      modal.off('click', '.no, close')
      var status = 'no'
      done(status)
    })
  }

  if (action_button.modal_events) {
    action_button.modal_events.forEach(function (e) {
      modal.off(e.type, e.elements)
      modal.on(e.type, e.elements, e.callback)
    })
  }

  modal.on('hidden.bs.modal', function () {
    modal.off('click', '.ok')
    if (action_button.modal_events) {
      action_button.modal_events.forEach(function (e) {
        modal.off(e.type, e.elements)
      })
    }
  })

  modal.modal(modal_options)
}

function confirmDialogGet(modal, header, content, action_button, modal_options, done) {
  modal.find('.modal-dialog').removeClass().addClass('modal-dialog')
  if (modal_options && modal_options.modal_class) {
    modal.find('.modal-dialog').addClass(modal_options.modal_class)
  }
  modal.find('.modal-header .modal-title').html('<h4 class="modal-title">' + header + '</h4>')
  modal.find('.modal-body').html('').append(content)
  modal.find('.modal-footer').html('').append(`<button type="button" class="btn btn-default" data-dismiss="modal">${i18next.t('common.close')}</button>`)
  modal.find('.modal-footer').append('<button class="btn btn-primary ' + action_button.class + ' ok">' + action_button.name + '</button>')

  modal.off('click', '.ok')
  modal.on('click', '.ok', function () {
    modal.off('click', '.ok')
    var status
    var result
    var data = null
    if (action_button.post_data) data = action_button.data
    $.when(
      doAjaxGet(
        action_button.url,
        data,
        function (data) {
          result = data

          if (data.hasOwnProperty('status') && data.status === 'ok') {
            status = data.status
          } else {
            modal.find('.modal-header .modal-title').html(`<h4 class="modal-title">${i18next.t('common.error')}</h4>`)
            modal.find('.modal-body').html(i18next.t('common.error-ocurred-try-again'))
            modal.find('.modal-footer .ok').remove()
          }
        },
        function (sender, message, details) {
          debuglog(sender.status + ' - ' + details)

          modal.find('.modal-header .modal-title').html(`<h4 class="modal-title">${i18next.t('common.error')}</h4>`)
          modal.find('.modal-body').html(i18next.t('common.error-ocurred-try-again'))
          modal.find('.modal-footer .ok').remove()
        }
      )
    ).done(function () {
      if (!modal_options.disable_hide_modal) {
        modal.modal('hide')
      }
      done(status, result)
    })
  })

  modal.on('hidden.bs.modal', function () {
    modal.off('click', '.ok')
  })

  modal.modal(modal_options)
}

function clearFormElements(containerSelector) {
  jQuery(containerSelector).find(':input').each(function() {
    switch(this.type) {
        case 'password':
        case 'text':
        case 'textarea':
        case 'file':
        case 'select-one':
        case 'select-multiple':
        case 'date':
        case 'number':
        case 'tel':
        case 'email':
        case 'hidden':
            jQuery(this).val('');
            break;
        case 'checkbox':
        case 'radio':
            this.checked = false;
            break;
    }
  });
}

function parseJwt (token) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
};
